import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import { AlertBannerContext } from "@kivunova/kivufrontendcommon";
import { fetchGraphQL } from "../../Graphql/utils";
import {
  getAllCompaniesSuperAdminQuery,
  updateCompanyStatusMutation,
} from "../../Graphql/querries/companyQuery";
import { getCompanyEmployeeListSuperAdminQuery } from "../../Graphql/querries/employees";
import type {
  ListAllCompaniesResponse,
  GetAllCompaniesSuperAdminInput,
  UpdateCompanyStatusInput,
  UpdateCompanyStatusResponse,
} from "../../Graphql/types/company";

export interface CompanyUser {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
  role?: string | null;
}

export interface ListCompanyUsersResponse {
  listCompanyUsers?: { code: string; users: CompanyUser[] };
  listCompanyUsersSuperAdmin?: { code: string; users: CompanyUser[] };
}

export const useGetAllCompanies = () => {
  const { setAlert } = useContext(AlertBannerContext);
  return useMutation<
    ListAllCompaniesResponse,
    Error,
    GetAllCompaniesSuperAdminInput | void
  >({
    mutationKey: ["getAllCompaniesSuperAdmin"],
    mutationFn: (input) =>
      fetchGraphQL(
        getAllCompaniesSuperAdminQuery,
        { input: input ?? {} },
        setAlert,
      ),
  });
};

export const useUpdateCompanyStatus = () => {
  const { setAlert } = useContext(AlertBannerContext);
  return useMutation<
    UpdateCompanyStatusResponse,
    Error,
    UpdateCompanyStatusInput
  >({
    mutationKey: ["updateCompanyStatus"],
    mutationFn: (input) =>
      fetchGraphQL(updateCompanyStatusMutation, { input }, setAlert),
  });
};

/** Super admin: list users for a company (companyId in request). */
export const useListCompanyUsersSuperAdmin = () => {
  const { setAlert } = useContext(AlertBannerContext);
  return useMutation<ListCompanyUsersResponse, Error, { companyId: string }>({
    mutationKey: ["listCompanyUsersSuperAdmin"],
    mutationFn: ({ companyId }) =>
      fetchGraphQL(
        getCompanyEmployeeListSuperAdminQuery,
        { companyId },
        setAlert,
      ),
  });
};
